// MUI-free copy of Ui-components/home/client-served for the plain homepage.
import LazySection from '@/components/Common/LazySection';
import Container from '@/components/atoms/Container';
import React, {memo, useMemo} from 'react';
import LogoMarquee, {LogoMarqueeItem} from './LogoMarquee';
import styles from './ClientServed.module.scss';

// Two rows travelling in opposite directions, in pixels per second (deliberately unequal).
const ROW_SPEEDS = [40, 35] as const;

const ClientServed = (props: any) => {
    // `flush` drops the rows' 16px top/bottom padding from the layout (see LogoMarquee).
    const {heading, subheading, contentData, flush = false} = props;

    // Split down the middle, first row taking the extra logo on an odd count.
    const [topRow, bottomRow] = useMemo(() => {
        const items: LogoMarqueeItem[] = contentData ?? [];
        const half = Math.ceil(items.length / 2);
        return [items.slice(0, half), items.slice(half)];
    }, [contentData]);

    return (
        <div>
            {/* Skipped with no heading, rather than leaving an empty <h2> and its spacing. */}
            {heading && (
                <Container>
                    <div className={styles.header}>
                        <h2 className={`font-headers ${styles.heading}`}>{heading}</h2>
                        {subheading && <p className={`font-regular-text ${styles.subheading}`}>{subheading}</p>}
                    </div>
                </Container>
            )}
            {/* Deliberately outside the container: the rows run edge to edge. The wrapper reserves
                the rows' height while LazySection holds the logos back (CLS). */}
            <div className={flush ? styles.flushReserve : styles.reserve}>
                <LazySection>
                    <div className={flush ? styles.flushRows : styles.rows}>
                        <LogoMarquee items={topRow} direction="left" speed={ROW_SPEEDS[0]} flush={flush} />
                        <LogoMarquee items={bottomRow} direction="right" speed={ROW_SPEEDS[1]} flush={flush} />
                    </div>
                </LazySection>
            </div>
        </div>
    );
};

export default memo(ClientServed);
